import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Currency from 'components/currency';
import { useLoyaltyContext } from 'state/loyalty';
import { priceForCartEntry } from 'utils/menu/price';

import { PriceAndQuantity } from '../cart-item/price-and-quantity';
import { RedeemReward } from '../cart-item/redeem-reward';

import CartPreviewActions, {
  CartPreviewEditButton,
  CartPreviewIncrementor,
  CartPreviewRemoveButton,
  CartPreviewTitle,
  CartPreviewVisuallyHidden,
} from './cart-preview-actions';
import { CartPreviewEditContainer } from './styled/cart-preview-edit-container';
import { CartPreviewEntryContainer } from './styled/cart-preview-entry-container';
import { CartPreviewItem } from './styled/cart-preview-item';
import { ItemPrice } from './styled/item-price';
import { ICartPreviewEntry } from './types';
import { getIsOffer } from './utils';

const PeopleLabel = styled.span`
  color: ${Styles.color.grey.one};
  margin-right: 1rem;
`;

const RedeemRewardWrapper = styled.div`
  > div {
    margin: 1.25rem 0;
  }
`;

const CartPreviewEntry: React.FC<ICartPreviewEntry> = ({
  item,
  selectedOfferCartEntry,
  selectedOfferPrice,
  rewardApplied = false,
}) => {
  const { formatMessage } = useIntl();
  const isOffer = getIsOffer({ selectedOfferCartEntry, item });
  const itemPrice = isOffer ? selectedOfferPrice : priceForCartEntry(item);
  const { loyaltyEnabled, availableLoyaltyRewardsMap } = useLoyaltyContext();
  const loyaltyRewardAvailable = availableLoyaltyRewardsMap[item._id];
  const displayPriceWithLoyalty = !isOffer && loyaltyEnabled;
  const displayRedeemReward = !isOffer && loyaltyEnabled && loyaltyRewardAvailable;

  return (
    <CartPreviewEntryContainer>
      <CartPreviewItem>
        <CartPreviewTitle item={item} />
        {displayPriceWithLoyalty ? (
          <PriceAndQuantity item={item} rewardApplied={rewardApplied} />
        ) : (
          <ItemPrice>
            <Currency amount={itemPrice} />
          </ItemPrice>
        )}
      </CartPreviewItem>

      {displayRedeemReward && (
        <RedeemRewardWrapper>
          <RedeemReward
            isRewardApplied={rewardApplied}
            item={item}
            reward={loyaltyRewardAvailable}
          />
        </RedeemRewardWrapper>
      )}
      <CartPreviewActions isOffer={isOffer} item={item}>
        <CartPreviewEditContainer>
          <CartPreviewEditButton />
          <CartPreviewRemoveButton />
        </CartPreviewEditContainer>
        <CartPreviewIncrementor>
          {item.labelAsPerPerson && (
            <PeopleLabel>
              {formatMessage({
                id: 'people',
              })}
              :
            </PeopleLabel>
          )}
        </CartPreviewIncrementor>
        <CartPreviewVisuallyHidden />
      </CartPreviewActions>
    </CartPreviewEntryContainer>
  );
};

export default CartPreviewEntry;
